import { REACT_APP_BASE_URL} from "../Config/config";
import { encryptData } from "../Helper/Encryptions"
const usersrole = JSON.parse(localStorage.getItem("@users"));

export const GetMethod = async (item) => {
  const REACT_APP_Access_Token = localStorage.getItem("@accesstoken");
  try {
    const response = await fetch(REACT_APP_BASE_URL + item.url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": REACT_APP_Access_Token,
      },
    });
    const json = await response.json();
    if (json.status == false) {
      if (json.message == "Unauthorized!") {
        LogoutUser();
      }
    }
    return json;
  } catch (Error) {
    console.log("Error get api error", Error, item.url);
    return false;
  }
};
export const PostMethod = async (item) => {
  const REACT_APP_Access_Token = localStorage.getItem("@accesstoken");
  try {
    let token = REACT_APP_Access_Token;
    if (item.accesstoken) {
      token = item.accesstoken;
    }
    const response = await fetch(REACT_APP_BASE_URL + item.url, {
      method: item.method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": token, //item.authtoken,
      },
      body: JSON.stringify(item.params),
    });
    const json = await response.json();
    if (json.status == false) {
      if (json.message == "Unauthorized!") {
        LogoutUser();
      }
    }
    return json;
  } catch (error) {
    return false;
  }
};
export const LogoutUser = async () => {
  try {
    let url = "auth/logout";
    let method = "POST";
    let params = {
      email: encryptData(usersrole.email),
    };
    const response = await fetch(REACT_APP_BASE_URL + url, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-access-token": "",
      },
      body: JSON.stringify(params),
    });
    const json = await response.json();
    if (json.status == false) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      localStorage.clear();
      window.location.replace("/");
    }
  } catch (Error) {
    console.log("Error", Error);
  }
};

export const S3Upload=async(item)=>{
  try {
    const REACT_APP_Access_Token = localStorage.getItem("@accesstoken");
    let url=`${REACT_APP_BASE_URL}access/uploadfile`
    const formData = new FormData();
    formData.append("file", item.file);
    formData.append("contenttype", item.contenttype);
    formData.append("name", item.name);

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "x-access-token": REACT_APP_Access_Token
      },
      body: formData,
    });
    const json = await res.json();
    if (json.status == false) {
     
      return ""
    }else{

      return json.result
    }
  }catch(Error){
    console.log("Error S3Upload",Error)
    return false;
  }
}
export const GetPublicURL = async(URL) => {
  try {
    let url="access/getpublicurl"
    let method="POST"
    let params ={
      url:URL
    }
    const response = await PostMethod({url,method,params})

    if(response.status){
      return response.result
    }else{
      return ""
    }
  } catch (Error) {
    console.log("Error in GetPublicURL", Error)
    return ""
  }
}